import { defaultAggregations } from "../fragments";

export const getItemForPreview = /* GraphQL */ `
  query GetItemForPreview($id: ID!, $sk: String!) {
    getResource(id: $id, sk: $sk) {
      id
      sk
      workspaceId
      idInc
      name
      subject
      content {
        canvas {
          id
          type
          interactionType
          content
          config
          scoring
        }
      }
      scoringMethod
      contexts {
        items {
          id
          idInc
          idVendor
          sk
          type
          version
          maturity
          content {
            body
          }
          file {
            bucket
            name
            key
            size
          }
          name
          description
          createdAt
          updatedAt
        }
      }
      createdAt
      updatedAt
    }
  }
`;

export const getItemPreviewStudent = /* GraphQL */ `
  query GetItemPreview($id: ID!, $sk: String!) {
    getResource(id: $id, sk: $sk) {
      id
      sk
      idInc
      name
      content {
        canvas {
          id
          type
          interactionType
          content
          config
        }
      }
      contexts {
        items {
          id
          idInc
          idVendor
          sk
          type
          version
          maturity
          content {
            body
          }
          file {
            bucket
            name
            key
            size
          }
          name
          description
          createdAt
          updatedAt
        }
      }
      createdAt
      updatedAt
    }
  }
`;

export const getItemForClone = /* GraphQL */ `
  query GetItem(
    $input: ModelGetInput!
    $authorizationContext: AuthorizationContextInput
  ) {
    getItem(input: $input, authorizationContext: $authorizationContext) {
      id
      sk
      workspaceId
      schemaVersion

      idInc
      bankId
      name

      originIdInc
      originResourceId
      originWorkspaceId
      originBankId
      maturity
      visibility

      alignmentIds
      creatorId
      content {
        canvas {
          id
          type
          interactionType
          content
          config
          scoring
        }
      }
      contextIds
      interaction
      scoringMethod
    }
  }
`;

// Since this queries alignments, which has a messed up gql type, you
// cannot use typedGQL here. You have to use the raw gql query.
export const getItemForExam = /* GraphQL */ `
  query GetItem(
    $input: ModelGetInput!
    $authorizationContext: AuthorizationContextInput
  ) {
    getItem(input: $input, authorizationContext: $authorizationContext) {
      id
      sk
      workspaceId
      schemaVersion

      idInc
      bankId
      name

      originIdInc
      originResourceId
      originWorkspaceId
      originBankId
      maturity
      visibility

      alignmentIds
      alignments {
        items {
          id
          sk
          name
          abbreviation
          scope
        }
      }
      creatorId
      content {
        canvas {
          id
          type
          interactionType
          content
          config
          scoring
        }
      }
      contextIds
      interaction
      scoringMethod
    }
  }
`;

export const createItem = /* GraphQL */ `
  mutation CreateItem(
    $input: CreateItemInput!
    $authorizationContext: AuthorizationContextInput
  ) {
    createItem(input: $input, authorizationContext: $authorizationContext) {
      id
      sk
      workspaceId
      schemaVersion
    }
  }
`;

export const searchItems = /* GraphQL */ `
  query SearchUserResources(
    $filter: SearchableResourceFilterInput
    $sort: [SearchableResourceSortInput!]
    $aggs: [SearchableResourceAggsInput!]
    $limit: Int
    $nextToken: String
    $authorizationContext: AuthorizationContextInput
  ) {
    searchUserResources(
      filter: $filter
      sort: $sort
      aggs: $aggs
      limit: $limit
      nextToken: $nextToken
      authorizationContext: $authorizationContext
    ) {
      items {
        id
        sk
        alignmentIds
        alignments {
          items {
            id
            idPublisher
            abbreviation
            scope
            content
          }
        }
        author
        bankId
        blooms
        contextIds
        createdAt
        creatorId
        description
        dok
        dueAt
        editorId
        examItemAverageScore
        examItemLastUsedAt
        examItemUseCount
        excerpt
        grade
        idInc
        idVendor
        interaction
        isArchived
        isDeleted
        isUserFavorite
        isUserWatcher
        isUnlisted
        itemCount
        language
        maturity
        name
        questionIds
        schemaVersion
        subject
        tags { key value }
        type
        updatedAt
        version
        workspaceId
        contexts {
          items {
            id
            sk
            idInc
            name
          }
        }
        assignee {
          id
          firstName
          lastName
          avatarHash
        }
        creator {
          id
          firstName
          lastName
          avatarHash
        }
        file {
          bucket
          name
          key
          size
        }
        dimensions {
          width
          height
          scale
        }
        __typename
      }
      nextToken
      ${defaultAggregations}
      total
      __typename
    }
  }
`;

export const getItemDetails = /* GraphQL */ `
  query GetResource($id: ID!, $sk: String!) {
    getResource(id: $id, sk: $sk) {
      id
      sk
      idInc
      idVendor
      assets {
        items {
          id
          sk
          name
        }
      }
      alignments {
        items {
          id
          abbreviation
          scope
        }
      }
      author
      bankId
      blooms
      createdAt
      assignee {
        id
        sk
        firstName
        lastName
        avatarHash
      }
      creator {
        id
        sk
        firstName
        lastName
        avatarHash
      }
      reviewer {
        id
        sk
        firstName
        lastName
        avatarHash
      }
      contexts {
        items {
          id
          sk
          idInc
          name
          type
        }
      }
      relatives {
        id
        sk
        relationship
        resource {
          id
          sk
          idInc
          name
        }
      }
      description
      difficulty
      dok
      flesch
      fontScaling
      grade
      interaction
      keywords
      language
      lexile
      maturity
      name
      parccTextComplexity
      rmm
      scoringMethod
      subject
      wordCount
      tags {
        key
        type
        value
      }
      updatedAt
      workspaceId
    }
  }
`;
